import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-paciente-encontrado-od',
  templateUrl: './modal-paciente-encontrado-od.component.html',
  styleUrls: ['./modal-paciente-encontrado-od.component.css']
})
export class ModalPacienteEncontradoOdComponent implements OnInit{
  modalActual: string = 'solicitud'; // Controla qué modal se muestra

  constructor(
    public dialogRef: MatDialogRef<ModalPacienteEncontradoOdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
            private router: Router,
            private scheduleService: ScheduleService 

    
  ) {}

  usuario: any = {};

  dataUsuario: any;


  data_consulta: any = {};

  ngOnInit(): void {
        this.usuario = new EncriptacionService().getUserInfo();
    // console.log(this.usuario);

  }

  mostrarModal(tipo: string) {
    this.modalActual = tipo;
  }

  isLoading: boolean = false; // Variable para deshabilitar el botón

  confirmarMedico(aceptado: boolean) {
    if (this.isLoading) return;
  
    this.isLoading = true;
  
    Swal.fire({
      allowOutsideClick: false,
      html: `
        <div style="margin: 40px 0;">
          <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
          <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Espere por favor...</h1>
        </div>`,
      showConfirmButton: false,
    });
    Swal.showLoading();
  
    this.scheduleService.postAceptarConsultaOnDemand({
      id_doc: this.usuario.doc_id,
      aceptado: aceptado,
      tel_doc_od_id: this.data.paciente.tel_doc_od_id
    })
    .then(response => {
      Swal.close(); // Cierra el loading inicial
      this.data_consulta = response;
      this.dialogRef.close({ accepted: aceptado, data_consulta: this.data_consulta });
    
      if (this.data_consulta.status === false) {
        Swal.fire({
          html: `
            <div style="margin: 40px 0;">
              <i class="material-icons" style="color:#171994; font-size: 58px; margin-bottom:25px">mood_bad</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                ${this.data_consulta.message}
              </h1>
            </div>`,
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        Swal.fire({
          html: `
            <div style="margin: 40px 0;">
              <i class="material-icons" style="color:#171994; font-size: 58px; margin-bottom:25px">mood</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                ${this.data_consulta.message}
              </h1>
            </div>`,
          showConfirmButton: false,
          timer: 2000
        });
    
        // Espera un poco antes de redirigir
        setTimeout(() => {
          let url = `videoconsulta/${this.data_consulta.id_consulta}`;
          this.router.navigate([url]);
        }, 2000);
      }
    })
    
    .catch(error => {
      Swal.close();
      console.error("Error al enviar la respuesta del médico:", error);
      Swal.fire("Error", "Ocurrió un problema al aceptar la consulta. Intente nuevamente.", "error");
    })
    .finally(() => {
      this.isLoading = false;
    });
  }
  
  

  postAceptarConsultaOnDemand(params: any) {
    this.scheduleService.postAceptarConsultaOnDemand(params)
      .then(response => {
        this.data_consulta = response;
        // console.log("Respuesta del servicio:", response);
      })
      .catch(error => {
        console.error("Error al enviar la respuesta del médico:", error);
      });
  }


  confirmarPaciente(aceptado: boolean) {
    // console.log("Paciente ha decidido:", aceptado ? "Aceptar" : "Rechazar");
  
    Swal.fire({
      allowOutsideClick: false,
      html: `
        <div style="margin: 40px 0;">
          <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
          <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Espere por favor...</h1>
        </div>`,
      showConfirmButton: false,
    });
    Swal.showLoading();
  
    this.scheduleService.postIngresarAtencionOnDemand({
      use_id: this.usuario._id,
      aceptado: aceptado,
      tel_doc_od_id: this.data.consulta.tel_doc_od_id,
      id_doctor: this.data.consulta.id_doctor
    }).then(response => {
      Swal.close();
      this.dataUsuario = response;
      this.dialogRef.close({ accepted: aceptado });
  
      if (aceptado) {
        let url = `salaespera/${this.dataUsuario.tel_doc_app_boo_id}/${this.dataUsuario.tel_doc_app_boo_id}/${this.dataUsuario.med_con_id}`;
        this.router.navigate([url]);
      }
  
      // console.log("Paciente ha", aceptado ? "aceptado" : "cancelado", "la consulta.");
    }).catch(error => {
      Swal.close();
      console.error("Error al enviar la respuesta del paciente:", error);
      Swal.fire("Error", "Ocurrió un problema al procesar la solicitud. Intente nuevamente.", "error");
    });
  }
  

  postIngresarAtencionOnDemand(params: any) {
    this.scheduleService.postIngresarAtencionOnDemand(params)
      .then(response => {
        // console.log("Respuesta del servicio:", response);
      })
      .catch(error => {
        console.error("Error al enviar la respuesta del médico:", error);
      });
  }
  
}
